<app-navbar></app-navbar>
<section class="focus">
  <div class="flex-container" *ngIf="!twoFAActivated">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-12">
        <div class="login-form">
          <h1 class="ds-title-1">{{ 'login_screen.title' | translate }}</h1>
          <div *ngIf="blocked" class="blocked">
            <span class="icon-i-warning"></span>
            <p>
              {{ 'login_screen.blocked' | translate }}
              <a routerLink="/reset-password">{{ 'login_screen.blocked_reset' | translate }} </a>.
            </p>
          </div>

          <app-google-button class="google-button" [locale]="locale" (googleSignIn)="googleLogin($event)"></app-google-button>

          <div class="or-separator align-center" id="or">
            <p>{{ 'login_screen.or' | translate }}</p>
          </div>

          <form [formGroup]="loginForm" #loginFormEl="ngForm" (ngSubmit)="signIn()">
            <div class="ds-form-row" [ngClass]="{ 'has-error': loginFormEl.submitted && emailControl.invalid }">
              <label class="ds-ui-2" for="email">{{ 'login_screen.email' | translate }}</label>
              <input
                type="email"
                id="email"
                formControlName="email"
                autocomplete="email"
                class="ds-input"
                [ngClass]="{ 'is-invalid': loginFormEl.submitted && emailControl.invalid }"
                [placeholder]="'placeholder.email' | translate"
                data-cy="input-email"
              />
              <div *ngIf="loginFormEl.submitted && emailControl.invalid" class="ds-input-error">
                <div *ngIf="emailControl.hasError('required')">{{ 'login_screen.email_req' | translate }}</div>
                <div *ngIf="!emailControl.hasError('required') && emailControl.hasError('email')">
                  {{ 'profile.personalDetails.error.format' | translate }}
                </div>
              </div>
            </div>

            <div class="ds-form-row" [ngClass]="{ 'has-error': loginFormEl.submitted && passwordControl.invalid }">
              <label class="ds-ui-2" for="password">{{ 'login_screen.password' | translate }}</label>
              <div class="input-wrapper">
                <input
                  id="password"
                  [type]="passwordVisible ? 'text' : 'password'"
                  formControlName="password"
                  class="ds-input"
                  [ngClass]="{ 'is-invalid': loginFormEl.submitted && passwordControl.invalid }"
                  [placeholder]="'login_screen.password' | translate"
                  data-cy="input-password"
                />
                <app-ds-icon
                  (click)="passVisibility()"
                  class="visibility"
                  [name]="passwordVisible ? 'eye-off' : 'eye'"
                  color="var(--color-core-neutral-7)"
                  size="icon-size-2"
                ></app-ds-icon>
              </div>
              <div *ngIf="loginFormEl.submitted && passwordControl.invalid" class="ds-input-error">
                <div>{{ 'login_screen.password_req' | translate }}</div>
              </div>
            </div>

            <div *ngIf="error" class="ds-form-row">
              <div class="ds-input-error">
                {{ (deDisabled ? 'login_screen.deDisabled' : invalidCall ? 'no_survey.sorry.p1' : 'login_screen.alert') | translate }}
                <span *ngIf="!blocked && left_attempts && left_attempts > 0">
                  {{ 'login_screen.warning_1' | translate }} {{ left_attempts }} {{ 'login_screen.warning_2' | translate }}
                </span>
              </div>
            </div>

            <div class="ds-form-row">
              <app-ds-button variant="primary" width="auto" [isLoading]="loading" type="submit" data-cy="btn-submit">
                {{ 'login_screen.cta1' | translate }}
              </app-ds-button>
            </div>
          </form>
          <div class="links-wrapper">
            <p>
              <a routerLink="/reset-password"> {{ 'login_screen.forgot' | translate }} </a>
            </p>
            @if (showRegisterButton) {
              <p class="ds-heading-2">
                {{ 'login_screen.no_account' | translate }}
                <a (click)="goRegister()"> {{ 'login_screen.sign_up' | translate }}</a>
              </p>
            }
          </div>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-container" *ngIf="twoFAActivated">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-12">
        <div class="code-form">
          <h1 class="ds-title-1">{{ '2fa.login.title' | translate }}</h1>
          <p>{{ '2fa.login.p' | translate: { phoneNumber: hiddenPhone } }}</p>
          <div class="code-wrapper">
            <div class="input-boxes">
              <span
                *ngFor="let item of [0, 1, 2, 3, 4, 5]"
                [class.active]="verifyCodeInput.value[item]"
                [class.focus]="item === 0 ? true : verifyCodeInput.value[item - 1]"
              >
                {{ verifyCodeInput.value[item] }}
              </span>
            </div>
            <input
              class="code-input"
              #verifyCodeInput
              autocomplete="one-time-code"
              type="tel"
              [(ngModel)]="inputCode"
              (ngModelChange)="inputUpdate($event)"
            />
            <p *ngIf="error" class="error">{{ '2fa.code.error' | translate }}</p>
          </div>
          <div class="fix-bottom">
            <div class="links">
              <app-ds-link (click)="resendCode()" variant="neutral" class="inline-link">
                {{ '2fa.code.resend' | translate }}
              </app-ds-link>
              <app-ds-link [href]="getArticle()" target="_blank" variant="neutral" class="inline-link">
                {{ '2fa.code.needHelp' | translate }}
              </app-ds-link>
            </div>
          </div>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
</section>
